export default __webpack_public_path__ + "static/mooc_footer_graphic-a583cf889784a2efa36339c6c09bc270.png";